import { Container } from '@hivebrite/design-system/Container';

import Grid, { Row, Col } from 'hb-react/shared/components/DesignSystem/Grid';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout = ({ children }: LayoutProps) => (
  <Container height="auto">
    <Grid width="100%">
      <Row>
        <Col width={1}>{children}</Col>
      </Row>
    </Grid>
  </Container>
);

export default Layout;
